<template>
  <div class="enhance-tag">
    <template v-for="item in shorexTags">
      <img class="enhance-tag-item" v-if="item.imageUe" :src="item.imageUe" :style="{marginBottom: marginBottom+'px'}" alt="" :key="item.id"/>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    shorexTags: {
      type: Array,
      default() {
        return []
      }
    },
    marginBottom: {
      type: [String, Number],
      default: '4'
    }
  },

  
  
}
</script>

<style lang="less" scoped>
.enhance-tag{
  display: flex;
  flex-wrap: wrap;
}

.enhance-tag-item:last-child {
  margin-right: 0 !important;
}

.enhance-tag-item{
  height: 20px;
  display: block;
  margin-right: 7px;
  margin-bottom: 4px;
}
</style>